import { render } from "./Profilers.vue?vue&type=template&id=0a0de3da&ts=true"
import script from "./Profilers.vue?vue&type=script&lang=ts"
export * from "./Profilers.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__